export const CDN_URL = import.meta.env.VITE_CDN_URL;
export const HACKLE_BROWSER_SDK_KEY = import.meta.env.VITE_HACKLE_BROWSER_SDK_KEY;
export const API_URL = import.meta.env.VITE_API_URL;
export const API_ENDPOINT = `${API_URL}/api`;
export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;
export const CDN_INTEGRATION_URL = import.meta.env.VITE_CDN_INTEGRATION_URL;
export const COURSE_API_URL = import.meta.env.VITE_COURSE_API_URL;
export const COURSE_API_URL_INTERNAL = import.meta.env.VITE_COURSE_API_URL_INTERNAL;
